import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { randuBlogService } from "../services/api";

const BlogRanduJobLogsPage = () => {
  const { id } = useParams();
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      const res = await randuBlogService.jobLogs(id);
      if (res.success) setItems(res.items || []);
    })();
  }, [id]);

  return (
    <MasterLayout>
      <Breadcrumb title={`Blog kuyruk logları #${id}`} />
      <Link to="/blog-randu/jobs" className="btn btn-link mb-2">
        ← Kuyruk
      </Link>
      <div className="card">
        <div className="card-body">
          <ul className="list-unstyled small">
            {items.map((l) => (
              <li key={l.id} className="mb-2 border-bottom pb-2">
                <span className="text-secondary">{new Date(l.created_at).toLocaleString("tr-TR")}</span>{" "}
                <span className="badge bg-light text-dark">{l.level}</span> {l.message}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </MasterLayout>
  );
};

export default BlogRanduJobLogsPage;
